/**
 * Room and Beds24 texts of the results block, read from the page HTML (0.9.3): PHP prints them in a hidden
 * <div class="pap-texts"> (src/Content/ResultsTexts.php) and TranslatePress translates them on the server, like
 * the labels list. The API JSON keeps the French originals for tools and tests; the cards never show them when
 * the page has the text.
 *
 *   room.<roomId>.name | slogan | short | capacity | bedding | floor | badge | hl.<n>   plain text
 *   room.<roomId>.long | ideal                                                         sanitised HTML
 *   feature.<featureId>                                                                plain text
 *   rate.desc.<offerId> (+ data-rooms)                                                 sanitised HTML
 */

/**
 * @param {ParentNode} root
 * @returns {{has: (key: string) => boolean, text: (key: string) => ?string, html: (key: string) => ?string,
 *   rateDesc: (roomId: number, offerId: number) => ?string}}
 */
export function readTexts(root = document) {
	const entries = new Map();
	const rates = new Map(); // offerId → [{rooms: Set, html}]
	for (const el of root.querySelectorAll('.pap-texts [data-k]')) {
		const key = el.dataset.k;
		if (key.startsWith('rate.desc.')) {
			const offer = Number(key.slice(10));
			const list = rates.get(offer) || [];
			list.push({ rooms: new Set((el.dataset.rooms || '').split(/\s+/).filter(Boolean).map(Number)), html: el.innerHTML });
			rates.set(offer, list);
		} else if (!entries.has(key)) {
			// Every results block carries the same list: the first value wins.
			entries.set(key, el.tagName === 'DIV' ? { html: el.innerHTML } : { text: el.textContent });
		}
	}
	return {
		has: (key) => entries.has(key),
		text: (key) => entries.get(key)?.text ?? null,
		html: (key) => entries.get(key)?.html ?? null,
		rateDesc: (roomId, offerId) => (rates.get(offerId) || []).find((r) => r.rooms.has(roomId))?.html ?? null
	};
}

/** No page texts (tests, a block outside WordPress): every lookup misses, the API values are used. */
export const NO_TEXTS = { has: () => false, text: () => null, html: () => null, rateDesc: () => null };
